import React from "react";
import {observer} from "mobx-react";
import {
    IChangePasswordFormViewModel
} from "../../../../../services/user/models/change-password/change-password-form-view-model.interface";
import {PasswordFieldEditorComponent} from "../../../../../components/forms/password/password-field-editor.component";
import {FormComponent} from "../../../../../components/forms/form.component";
import styled from "styled-components";

interface AgencyChangePasswordEditorComponentProps {
    changePasswordEditor: IChangePasswordFormViewModel
}

const FormComponentContainer  = styled(FormComponent)`
    display: flex;
    gap: ${props => props.theme.spacing.flexGap40};
`;

export const AgencyChangePasswordEditorComponent: React.FC<AgencyChangePasswordEditorComponentProps> = observer((props) => {
    const fields = props.changePasswordEditor.fields;

    return (
        <FormComponentContainer>
            <PasswordFieldEditorComponent key={fields.oldPassword.fieldName} field={fields.oldPassword}/>
            <PasswordFieldEditorComponent key={fields.newPassword.fieldName} field={fields.newPassword}/>
            <PasswordFieldEditorComponent key={fields.confirmPassword.fieldName} field={fields.confirmPassword}/>
        </FormComponentContainer>
    );
})